import { useState } from "react";
import { editDataStore } from "../../../surveyStore";
import { useEffect } from "react";
import { orderedItems } from "../../../helpers";

// The survey flattened into the order it is answered in. `useFetchOrderedQuestions` slices it at
// the item being edited to get "the questions above this one", which is the list a skip logic can
// key on - so a flatten that disagreed with what the builder shows offered questions that come
// after the item and hid ones that come before it.
const useGetOrderedSurveys = () => {
   // const { surveyData } = useSurveyStore();
   const surveyData = editDataStore((state) => state.surveyData);
   const [surveyOrdered, setSurveyOrdered] = useState([]);

   useEffect(() => {
      const getOrderArray = (items) => {
         let orderArr = [];
         orderedItems(items).forEach((item) => {
            orderArr.push(item);
            if (item.innerItems?.length > 0) {
               orderArr = orderArr.concat(getOrderArray(item.innerItems));
            }
         });
         return orderArr;
      };

      if (surveyData.length > 0) {
         const orderArray = getOrderArray(surveyData);
         setSurveyOrdered(orderArray);
      }
   }, [surveyData]);

   return { surveyOrdered };
};

export default useGetOrderedSurveys;
